import CacheStorageService from "./cacheStorage.service";


class StatusApplicationTypeService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    /**
* @author Adriana Fernandez
* @description Get statusApplicationType by keyGroup
* @date 26-12-2023
* @param {String} keyGroup
* @param {String} token
* @returns {Object}
* @memberof ContractService
*/
    async getStatusApplicationType(token, keyGroup) {
        const url = new URL(`${this.apiUrl}/status-application-type`);
        url.searchParams.append('keyGroup', keyGroup);

        const cache = new CacheStorageService();
        const response = await cache.fetchData(url, token);
        return response.data;
    }
}


export { StatusApplicationTypeService as default }
